import { IPSpinner } from 'baseComponents';
import { IPStack } from 'baseComponents/Stack/IPStack';

import { globalStackStylesNoHeightPaddingSmall, globalStackTokensGapLarge } from 'globalStyles';
import { IPSpinnerSize } from "baseComponents/Spinner/IPSpinner";

interface ISceneLoaderProps {}

const SceneLoader = (props: ISceneLoaderProps) => {
  return (
    <IPStack
      verticalFill
      horizontalAlign="center"
      verticalAlign="center"
      styles={globalStackStylesNoHeightPaddingSmall}
      tokens={globalStackTokensGapLarge}
    >
      <IPSpinner size={IPSpinnerSize.large} />
    </IPStack>
  );
};

export default SceneLoader;
